<template>
  <div style="position:relative;">
    <div class="log01">
      <div class="log02">
        <Form ref="formInline" :model="formInline" class="log03">
          <div class="log04">
            <img src="../../../public/images/logo.png">
          </div>
          <FormItem prop="user">
            <Input type="text" v-model="formInline.phone" placeholder="Phone">
              <Icon type="ios-person-outline" slot="prepend"></Icon>
            </Input>
          </FormItem>
          <FormItem prop="password">
            <Input type="password" v-model="formInline.password" placeholder="Password">
              <Icon type="ios-lock-outline" slot="prepend"></Icon>
            </Input>
          </FormItem>
          <FormItem>
            <Button :loading="loadings" type="success" v-on:keyup.13="handleSubmit('formInline')" long="long"
              @click="handleSubmit('formInline')">登录
            </Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
  import httpIndex from '@/api/index';
  import {USERSTATUS, SYNCUSERSTATUS} from "../../store/types";

  export default {
    name: "login",
    data() {
      return {
        formInline: {
          phone: '',
          password: '',
        },
        loadings:false,//是否加载
      }
    },
    created() {
      var lett = this;
      // document.onkeydown = function (e) {
      //   var key = window.event.keyCode;
      //   if (key == 13) {
      //     lett.handleSubmit('123');
      //   }
      // }
    },
    mounted() {
      if (sessionStorage.getItem('user') !== 'null') {
        this.$router.push('/index/index');
      }
    },
    methods: {
      handleSubmit(name) {
        var me = this;
        if (me.formInline.phone == '') {
          me.$message.error('请输入手机号');
          return false;
        }
        if (me.formInline.password == '') {
          me.$message.error('请输入密码');
          return false;
        }
        let data = {
          'mobile':me.formInline.phone,
          'passWord':me.formInline.password
        }
        me.loadings = true;
        httpIndex.login(data).then(res => {
          me.loadings = false;
          switch (res.code) {
            case "0000":
              me.$message.success("登录成功");
              me.$store.dispatch(SYNCUSERSTATUS,res.data.userName);
              sessionStorage.setItem('user',JSON.stringify(res.data));
              setTimeout(function () {
                me.$router.push('/index/index')
              }, 2000)
              break;
            case "1001":
              me.$message.error('密码错误');
              break;
            case "1002":
              me.$message.error('手机号码不存在');
              break;
            case "1003":
              me.$message.error('密码错误');
              break;
            case "1004":
              me.$message.error('无角色');
          }
        })
      },
    }
  }
</script>

<style scoped>
  @import "index.css";
</style>